var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-footer"},[_c('div',{staticClass:"footer-bug-button"},[_c('span',{on:{"click":function($event){_vm.isBugModalOpen = true}}},[_vm._v("\n      Report A Bug\n    ")])]),_vm._v(" "),_c('BugReportModal',{attrs:{"isOpen":_vm.isBugModalOpen},on:{"update:isOpen":function($event){_vm.isBugModalOpen = $event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2700d794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/ContentFooter.vue
// module id = lm93
// module chunks = 1